module.exports = __webpack_public_path__ + "static/media/icons8-twitter.6f7ac4f6.svg";